//for-formated
import { gql } from 'graphql-request'

export const CREATE_GAME_GOLD_MINER = gql`
  mutation CREATE_GAME_GOLD_MINER(
    $userId: Int!
    $giftIdEarning: Int
    $valueGift: Int
  ) {
    createGameGoldMiner(
      userId: $userId
      giftIdEarning: $giftIdEarning
      valueGift: $valueGift
    ) {
      error
      status
      data {
        id
        userId
        giftIdEarning
        valueGift
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAME_GOLD_MINER = gql`
  query GET_GAME_GOLD_MINER($gameGoldMinerId: Int!) {
    getGameGoldMiner(gameGoldMinerId: $gameGoldMinerId) {
      error
      status
      data {
        id
        userId
        giftIdEarning
        valueGift
        createdAt
        updatedAt
      }
    }
  }
`
export const GET_GAMES_GOLDS_MINERS = gql`
  query GET_GAMES_GOLDS_MINERS(
    $take: Int
    $skip: Int
    $userId: Int
    $giftIdEarning: Int
    $valueGift: Int
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGamesGoldsMiners(
      take: $take
      skip: $skip
      userId: $userId
      giftIdEarning: $giftIdEarning
      valueGift: $valueGift
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        userId
        giftIdEarning
        valueGift
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAME_GOLD_MINER_FIRST = gql`
  query GET_GAME_GOLD_MINER_FIRST(
    $id: Int
    $userId: Int
    $giftIdEarning: Int
    $valueGift: Int
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGameGoldMinerFirst(
      id: $id
      userId: $userId
      giftIdEarning: $giftIdEarning
      valueGift: $valueGift
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        userId
        giftIdEarning
        valueGift
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAMES_GOLDS_MINERS_GIFTS = gql`
  query GET_GAMES_GOLDS_MINERS_GIFTS {
    getGamesGoldsMinersGifts {
      error
      status
      data {
        id
        giftId
        value
        giftName
        imgGift
        imgGiftFrame
      }
    }
  }
`

export const GET_GAMES_GOLDS_MINERS_RANKING = gql`
  query GET_GAMES_GOLDS_MINERS_RANKING(
    $createdAtInitial: String!
    $createdAtFinal: String
    $take: Int
  ) {
    getGamesGoldsMinersRanking(
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
      take: $take
    ) {
      error
      status
      data {
        userId
        total
        userName
        imgUser
      }
    }
  }
`

export const GET_GAME_GOLD_MINER_COUNT = gql`
  query GET_GAME_GOLD_MINER_COUNT(
    $userId: Int
    $giftIdEarning: Int
    $valueGift: Int
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGameGoldMinerCount(
      userId: $userId
      giftIdEarning: $giftIdEarning
      valueGift: $valueGift
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        count
      }
    }
  }
`

// "Meus ganhos": jogadas do PRÓPRIO usuário (servidor ignora userId), agrupadas
// por lote + presente, mais recente primeiro. Mesmo field — não mexe no gateway.
export const GET_GOLD_MINER_HISTORY = gql`
  query GET_GOLD_MINER_HISTORY($take: Int, $skip: Int, $history: Boolean) {
    getGamesGoldsMiners(take: $take, skip: $skip, history: $history) {
      error
      status
      data {
        giftIdEarning
        valueGift
        quantity
        createdAt
        giftName
        imgGift
      }
    }
  }
`
